// removed by extract-text-webpack-plugin
module.exports = {"colored-background":"colored-background___27xs4","coloredBackground":"colored-background___27xs4","header":"header___3rEpp"};